module.exports = __webpack_public_path__ + "static/media/outsideBedroom.0691f66e.jpg";